// import {
//   Box,
//   Chip,
//   IconButton,
//   Menu,
//   MenuItem,
//   Stack
// } from '@mui/material';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import { useState, useRef } from 'react';

// const SignatureSelection = ({ signatures, selectedSignatures, setSelectedSignatures }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const boxRef = useRef(null);

//   const handleIconClick = () => {
//     setAnchorEl(prev => (prev ? null : boxRef.current)); // Toggle dropdown
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleSelect = (sig) => {
//     const exists = selectedSignatures.some(s => s.enterprise_id === sig.enterprise_id);
//     if (!exists) {
//       setSelectedSignatures([...selectedSignatures, sig]);
//     }
//   };

//   const handleDelete = (id) => {
//     setSelectedSignatures(selectedSignatures.filter(sig => sig.enterprise_id !== id));
//   };

//   const handleDragEnd = (result) => {
//     if (!result.destination) return;
//     const updated = [...selectedSignatures];
//     const [moved] = updated.splice(result.source.index, 1);
//     updated.splice(result.destination.index, 0, moved);
//     setSelectedSignatures(updated);
//   };

//   return (
//     <Stack spacing={1}>
//       <Box
//         ref={boxRef}
//         sx={{
//           border: '1px solid #ccc',
//           borderRadius: 1,
//           padding: '0 0 0 5px',
//           display: 'flex',
//           alignItems: 'center',
//           flexWrap: 'wrap',
//           minHeight: '45px',
//           position: 'relative',
//         }}
//       >
//         <DragDropContext onDragEnd={handleDragEnd}>
//           <Droppable droppableId="chips" direction="horizontal">
//             {(provided) => (
//               <Box
//                 ref={provided.innerRef}
//                 {...provided.droppableProps}
//                 sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flexGrow: 1 }}
//               >
//                 {selectedSignatures.map((sig, index) => (
//                   <Draggable key={sig.enterprise_id} draggableId={sig.enterprise_id} index={index}>
//                     {(provided) => (
//                       <Chip
//                         label={sig.enterprise_id}
//                         onDelete={() => handleDelete(sig.enterprise_id)}
//                         ref={provided.innerRef}
//                         {...provided.draggableProps}
//                         {...provided.dragHandleProps}
//                       />
//                     )}
//                   </Draggable>
//                 ))}
//                 {provided.placeholder}
//               </Box>
//             )}
//           </Droppable>
//         </DragDropContext>

//         <IconButton onClick={handleIconClick}>
//           <ArrowDropDownIcon />
//         </IconButton>
//       </Box>

//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//         PaperProps={{
//           style: {
//             width: boxRef.current ? boxRef.current.offsetWidth : undefined
//           }
//         }}
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'left'
//         }}
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'left'
//         }}
//       >
//         {/* {signatures.map((sig) => (
//           <MenuItem key={sig.enterprise_id} onClick={() => handleSelect(sig)}>
//             {sig.enterprise_id}
//           </MenuItem>
//         ))} */}
//         {signatures.map((sig) => {
//           const isSelected = selectedSignatures.some(
//             (s) => s.enterprise_id === sig.enterprise_id
//           );

//           return (
//             <MenuItem
//               key={sig.enterprise_id}
//               onClick={() => handleSelect(sig)}
//               selected={isSelected} // highlights selected ones
//             >
//               {sig.enterprise_id}
//               {isSelected && (
//                 <span style={{ marginLeft: "auto", color: "green" }}>✔</span>
//               )}
//             </MenuItem>
//           );
//         })}
//       </Menu>
//     </Stack>
//   );
// };

// export default SignatureSelection;


import {
  Box,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Stack
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useState, useRef } from 'react';

const SignatureSelection = ({ signatures, selectedSignatures, setSelectedSignatures }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const boxRef = useRef(null);

  const handleIconClick = () => {
    setAnchorEl(prev => (prev ? null : boxRef.current)); // Toggle dropdown
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (sig) => {
    const exists = selectedSignatures.some(s => s.enterprise_id === sig.enterprise_id);
    if (!exists) {
      setSelectedSignatures([...selectedSignatures, sig]);
    }
  };

  const handleDelete = (id) => {
    setSelectedSignatures(selectedSignatures.filter(sig => sig.enterprise_id !== id));
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const updated = [...selectedSignatures];
    const [moved] = updated.splice(result.source.index, 1);
    updated.splice(result.destination.index, 0, moved);
    setSelectedSignatures(updated);
  };

  return (
    <Stack spacing={1}>
      <Box
        ref={boxRef}
        sx={{
          border: '1px solid #ccc',
          borderRadius: 1,
          padding: '0 0 0 5px',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          minHeight: '45px',
          position: 'relative',
        }}
      >
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="chips" direction="horizontal">
            {(provided) => (
              <Box
                ref={provided.innerRef}
                {...provided.droppableProps}
                sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flexGrow: 1 }}
              >
                {selectedSignatures.map((sig, index) => (
                  <Draggable key={sig.enterprise_id} draggableId={sig.enterprise_id} index={index}>
                    {(provided) => (
                      <Chip
                        label={sig.enterprise_id}
                        onDelete={() => handleDelete(sig.enterprise_id)}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      />
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </Box>
            )}
          </Droppable>
        </DragDropContext>

        <IconButton onClick={handleIconClick}>
          <ArrowDropDownIcon />
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            width: boxRef.current ? boxRef.current.offsetWidth : undefined
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        {signatures.map((sig) => {
          const isSelected = selectedSignatures.some(
            (s) => s.enterprise_id === sig.enterprise_id
          );

          return (
            <MenuItem
              key={sig.enterprise_id}
              onClick={() => !isSelected && handleSelect(sig)} // block re-select
              selected={isSelected}
              disabled={isSelected} // disable already selected
              sx={{ opacity: "unset !important"}}
            >
              {sig.enterprise_id}
              {isSelected && (
                <span style={{ marginLeft: "auto", color: "green" }}>✔</span>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </Stack>
  );
};

export default SignatureSelection;
